import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-global-quartz',
  templateUrl: './global-quartz.component.html',
  styleUrls: ['./global-quartz.component.css']
})
export class GlobalQuartzComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
